<template>
  <div class="suggested-actions-header">
    <span class="suggested-actions-title">{{ suggestedActionsText }}</span>
    <EscTooltip
      :tooltip-meta="{ icon: { key: 'esc ' } }"
      @closePopup="handleCloseSuggestedActions"
    />
  </div>
</template>

<script>
import EscTooltip from '@/components/widgets/EscTooltip';
import EventBus from '@/utilities/eventBus';

export default {
  components: {
    EscTooltip,
  },
  props: {
    numberOfActions: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  computed: {
    suggestedActionsText() {
      return this.numberOfActions
        ? `${this.numberOfActions} ${this.translate('suggestedActions')}`
        : this.translate('noSuggestedActions');
    },
  },
  methods: {
    handleCloseSuggestedActions() {
      EventBus.$emit('note:toggleSuggestedActions', false);
    },
  },
};
</script>

<style lang="scss">
.suggested-actions-header {
  @apply flex justify-between items-center px-3;

  .suggested-actions-title {
    @apply text-sm font-medium text-text-default;
  }

  .esc-button {
    .square-icon-wrap {
      @apply h-6 w-6;
    }
  }
}
</style>
